export default "__VITE_ASSET__D9jhvzRe__"